<mat-card>
  <mat-card-content>
    <form [formGroup]="clientForm" (ngSubmit)="onSubmit()" class="basic-form">
      <div fxLayout="row wrap" fxFlexAlign="center" class="row">
        <mat-form-field fxFlex="100" [fxFlex.gt-sm]="admin ? 50 : 100" class="p-10">
          <mat-label>Client Name</mat-label>
          <input type="text" matInput formControlName="clientName" placeholder="Client Name">
          <mat-error *ngIf="form.clientName.hasError('required')">
            Client Name is <strong>required</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="admin" fxFlex="100" [fxFlex.gt-sm]="admin ? 50 : 100" class="p-10">
          <mat-label>Choose scopes</mat-label>
          <mat-select multiple formControlName="scopes" placeholder="Scopes">
            <mat-option *ngFor="let scope of scopes" [value]="scope">
              {{ scope }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.scopes.hasError('required')">
            At least one Scope is <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div fxLayoutAlign="end center" fxLayoutGap="15px">
        <button type="submit" class="add-action-button" mat-flat-button color="primary"
          [disabled]="!clientForm.valid">
          <mat-icon>done</mat-icon> Save
        </button>
        <button type="button" class="reset-button" mat-stroked-button color="basic" (click)="showClientsView()">
          <mat-icon>clear</mat-icon> Cancel
        </button>
      </div>
    </form>
  </mat-card-content>
</mat-card>